module.exports = __webpack_public_path__ + "static/media/pk.1313cf41.svg";